module.exports = __webpack_public_path__ + "static/06-5b4ad62f48b8b956c2fb18099da1a6c4.png";